import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import $ from "jquery";
import axios from 'axios';
// import Draggable, {DraggableCore} from 'react-draggable';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { UsersService } from '../../services/user';
import './player.css';

import {
  ContentHeader,
  CoinsBox,
  BadgesBox,
  Dialog
} from '../../components';

export default class ViewPlayer extends Component {
  constructor(props) {
    super(props);

    this.loginRef = React.createRef();
    this.passwordRef = React.createRef();

    this.registerInteraction = this.registerInteraction.bind(this);

    this.state = {
      "ai_supplementary_creating_message": null,
      "ai_supplementary_content": null,
      "ai_supplementary_title": null,
      "ai_supplementary_thumb": null,
      "ai_supplementary_identity": null,
      "render_ai_supplementary_content": false,
      "ai_doubt_response_finish": false,
      "ai_supplementary_response_finish": null,
      "ai_doubt_response": null,
      "ai_doubt_identity": null,
      "ai_doubt": null,
      "render_ai_doubt": false,
      "render_ai_doubts": false,
      "ai_doubts": null,
      "render_ai_options": false,
      "render_ai": false,
      "render_coins_box": false,
      "render_badges_box": false,
      "render_summary": false,
      "course_info": null,
      "course_tree": null,
      "submodules": null,
      "interaction_uid": null,
      "content_uid": null,
      "node_uid": null,
      "activity_uid": this.props.match.params.activityUid,
      "has_required_objects": {},
      "progress": {},
      "activity": null,
      "ai_dom_content": "",
      "has_ai_connector": UsersService.hasAiConnector(),
      "render_leave_dialog": false
    }
  }

  componentWillMount() {
    AOS.init({
      offest: -50
    });
  }

  componentDidMount() {
    this.getCourseInfo();
    this.getCourseTree();
    this.onReceiveMessage();
  }

  onReceiveMessage() {
    var _this = this;
    window.addEventListener("message", function(e) {
      if (e.data.domContent) {
        _this.setState({
          "ai_dom_content": e.data.domContent.data
        })

        _this.getAiDoubts();
      }

      _this.onReceiveLearningPlayerMessage(e, _this)
    });
  }

  async registerInteraction(model) {
    // activity_data
    // interaction_uid
    // score
    // status
    var body = {
      status: model.status
    };
  
    if (model.score !== undefined) body.score = model.score;
  
    try {
      let activityObj = null;
  
      if (model.status.toLowerCase() === "Incomplete".toLowerCase()) {
        // activityObj = await UsersService.getInteractionDetails(model.interaction_uid);
        activityObj = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/interaction/uid/${model.interaction_uid}/details`, null, 'GET');
      }
  
      // fix(PLT-314): Ao visualizar uma atividade já completada o status muda para "Incomplete"
      // impedindo ou causando erros na geração do certificado.
      // Somente deve mudar o status da atividade para "Incomplete" se o status não for "Completed" ou "Passed".
      if (activityObj === null || (activityObj && (activityObj.status.toLowerCase() !== 'Completed'.toLowerCase() || activityObj.status.toLowerCase() !== 'Passed'.toLowerCase()))) {
        if (activityObj !== null && (activityObj.status.toLowerCase() === 'Completed'.toLowerCase() || activityObj.status.toLowerCase() === 'Passed'.toLowerCase())) {
          body.status = activityObj.status;
        }
        // const response = await UsersService.sendInteraction(model.interaction_uid, body);
        const response = await Sdk.dynamic.bridge(`cms/v1.0/learning/interaction/uid/${model.interaction_uid}`, body, 'PUT');
        // onChangeState({
        //   success: true,
        //   response
        // });
      }
    } catch(error) {
      console.log({
        error: "Você atingiu o número máximo de tentativas na atividade.",
        success: false
      })
    }

    this.getCourseTree();
  }

  onReceiveLearningPlayerMessage(e, target) {
    if (typeof e.data === "object" && "type" in e.data && "app_player" === e.data.type && "interaction.progress" === e.data.action) {
      const {
        value = {},
        activity_uid,
      } = e.data;
      const {
        completed = false,
        completed_objects = 0,
        required_objects = 0
      } = value;
      if (required_objects > 0) {
        this.setState(prevState => ({
          has_required_objects: {
            ...prevState.has_required_objects,
            [activity_uid]: !completed
          }
        }));
        let done = completed_objects * 100;
        let percentage = done / required_objects;
        this.setState(prevState => ({
          progress: {
            ...prevState.progress,
            [activity_uid]: percentage
          }
        }));
      }
    } else if (typeof e.data === "string") {
      this.registerInteraction(JSON.parse(e.data))
    }
  }

  async getCourseInfo() {
    var courseUid = this.props.match.params.courseUid;
    // var courseInfo = await UsersService.getCourseInfo(courseUid);
    var courseInfo = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/course/uid/${courseUid}`, null, 'GET')

    this.setState({
      "course_info": courseInfo
    });
  }

  getSubModules(modules) {
    var submodules = null;
    var moduleUid = this.props.match.params.moduleUid;
    var courseStatus = this.state.course_status;

    for (var i = 0; i < modules.length; i++) {
      if (modules[i].uid === moduleUid) {
        submodules = modules[i].childs;
      };
    };

    for (var i = 0; i < submodules.length; i++) {
      var activities = submodules[i].activities;
      for (var j = 0; j < activities.length; j++) {
        activities[j].status = courseStatus.activities.find(item => item.uid === activities[j].uid).status;
      }
    }

    this.setState({
      "submodules": submodules
    });
  }

  async getCourseTree() {
    var activitiesNavigation = [];
    var registerUid = this.props.match.params.registerUid;
    // var courseTree = await UsersService.getCourseTree(registerUid);
    // var courseStatus = await UsersService.getCourseStatus(registerUid);
    var courseTree = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`, null, 'GET');
    var courseStatus = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET');

    var treeWithInteractions = this.mergeNodesAndInteractions(courseTree, courseStatus.activities);

    for (var i = 0; i < courseTree.length; i++) {
      var childs = courseTree[i].childs;
      for (var j = 0; j < childs.length; j++) {
        var activities = childs[j].activities;
        for (let k = 0; k < activities.length; k++) {
          activitiesNavigation.push({
            "activity_uid": activities[k].uid,
            "node_uid": courseTree[i].uid,
            "first": i === 0 && k === 0,
            "last": (i === (courseTree.length - 1)) && (k === (activities.length - 1))
          })
        }
      }
    }

    this.setState({
      "course_tree": treeWithInteractions,
      "course_status": courseStatus,
      "activities_navigation": activitiesNavigation
    }, function() {
      this.getActivity();
      this.getSubModules(courseTree);
    });
  }

  mergeNodesAndInteractions(tree, statusActivities) {
    for (var i = 0; i < tree.length; i++) {
      var firstActivities = tree[i].activities;
      var firstChilds = tree[i].childs;

      for (var j = 0; j < statusActivities.length; j++) {
        for (var k = 0; k < firstActivities.length; k++) {
          if (statusActivities[j].uid === firstActivities[k].uid) {
            firstActivities[k].interaction_uid = statusActivities[j].interaction_uid;
          };
        };

        for (var l = 0; l < firstChilds.length; l++) {
          var secondActivities = firstChilds[l].activities;

          for (var m = 0; m < secondActivities.length; m++) {
            if (secondActivities[m].uid === statusActivities[j].uid) {
              secondActivities[m].interaction_uid = statusActivities[j].interaction_uid;
            };
          };
        };
      };
    };

    return tree;
  }

  downloadedActivity(activity) {
    var isDownloaded = false;

    if (activity.local_storage && activity.local_storage.state === "Downloaded") {
      isDownloaded = true;
    };

    return isDownloaded;
  }

  async getActivity() {
    var status = this.state.course_status;
    var activity = status.activities.find(act => act.uid === this.state.activity_uid);
    var interactionUid = activity.interaction_uid;
    // var contentUrl = await UsersService.getContentByInteraction(interactionUid);
    var contentOptions = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/interaction/uid/${interactionUid}/content/options`, null, 'GET');
    var env = Sdk.Api.enviroment[0];
    var projectUid = "-";

    if (Sdk.Api.authorization.activeProject != null)
    {
      projectUid = Sdk.Api.authorization.activeProject.uid;
    }

    var options = btoa(JSON.stringify(contentOptions));
    var player = `${Sdk.Api.domain}/product/learning_player/current/${Sdk.Api.projectKey}/p/${projectUid}/${env}/init?custom_options=${options}`;

    this.setState({
      // "interaction_uid": content.interaction_uid,
      // "node_uid": content.node_uid,
      "activity": activity,
      "content_url": player
    })
  }

  // getCustomOptions() {
  //   var obj = {
  //     access_token: UsersService.getUser().access_token,
  //     activity_uid: this.state.activity_uid,
  //     api_env: "production",
  //     content_uid: this.state.content_uid,
  //     course_uid: this.props.match.params.courseUid,
  //     // domain: "api-euconquisto.azure-api.net",
  //     domain: "api.digitalpages.com.br",
  //     interaction_uid: this.state.interaction_uid,
  //     node_uid: this.state.node_uid,
  //     project_key: "a59e9223e8ca4e5ab371d20c72bb5479",
  //     project_uid: "e70dc54e-a474-ec11-94f6-dc98407f3361",
  //     register_uid: this.props.match.params.registerUid,
  //     social_media_connector_uid: "38a40bfe-c5a3-ec11-a99b-dc98407f1b02"
  //   }

  //   return btoa(JSON.stringify(obj));
  // }

  onBack() {
    var courseUid = this.props.match.params.courseUid;
    var registerUid = this.props.match.params.registerUid;
    this.props.history.push('/curso/' + courseUid + '/' + registerUid);
  }

  getHtmlString(html) {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  async fetchGeminiStreamingJson(model, prompt) {
    var aiConnectorUid = Sdk.authorization.activeProject.connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var apiUrl = `${Sdk.Api.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/${model}`
    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${UsersService.getUser().accessToken}`,
        "Api-Env": Sdk.Api.enviroment,
        "Project-Key": Sdk.Api.projectKey
      },
      body: JSON.stringify({
        "prompt": prompt,
        "response_mime_type" : "application/json"
      })
    };

    let decoder = new TextDecoder();
    let result = "";

    const response = await fetch(apiUrl, options);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const reader = response.body.getReader();

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }
      
      result += decoder.decode(value, { stream: true });
      console.log(result);
    }

    return JSON.parse(this.cleanToSingleLine(this.cleanMarkdown(result)));
  }

  async fetchGeminiStreaming(model, prompt, state, mathRandom) {
    var _this = this;
    var aiConnectorUid = Sdk.authorization.activeProject.connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    var apiUrl = `${Sdk.Api.domain}/insights/v1.1/generative/connector/uid/${aiConnectorUid}/${model}`
    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${UsersService.getUser().accessToken}`,
        "Api-Env": Sdk.Api.enviroment,
        "Project-Key": Sdk.Api.projectKey
      },
      body: JSON.stringify({
        "prompt": prompt
      })
    };

    let decoder = new TextDecoder();
    let result = "";

    const response = await fetch(apiUrl, options);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const reader = response.body.getReader();

    var obj = {};
    obj[state] = "";


    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      if (this.state.ai_doubt_identity === mathRandom) {
        // result += decoder.decode(value, { stream: true });
        // result += decoder.decode(value, { stream: true }).replace(/\r?\n|\r/g, " ");
        result += decoder
          .decode(value, { stream: true })
          .replace(/(\r?\n|\r)/g, "") // Remove quebras de linha
          .replace(/\s+/g, " ");      // Substitui múltiplos espaços por um único espaço
        obj[state] = result;
        _this.setState(obj)
      }
      console.log(result);
    }

    if (this.state.ai_doubt_identity === mathRandom) {
      return {"finished": true};  
    }
  }

  async onToggleAiDoubt(index) {
    var _this = this;
    const {
      ai_doubt,
      ai_doubts
    } = this.state;

  
    this.setState({
      "ai_doubt_response": null,
      "render_ai_doubt": !this.state.render_ai_doubt,
      "ai_doubt": index
    })

    if (index !== null) {
      var random = (Math.random() + 1).toString(36).substring(7);
      this.setState({
        "ai_doubt_identity": random
      });
      // var content = document.querySelector(".rdp-composer-player-home").innerText;
      var content = this.state.ai_dom_content;
      // var message = `Responda esta dúvida de um aluno de forma objetiva: '${ai_doubts[index].doubt}', com base no conteúdo textual a seguir: '${content}'`;
      var message = `Responda esta dúvida de um aluno com no mínimo 6000 caracteres em tags html. Por favor, na resposta não retorne nenhuma tag <body>, nem <html>, somente o que seria dentro do <body>. Também não retorne nenhum markdown e nem asteriscos: '${ai_doubts[index].doubt}', com base no conteúdo textual a seguir: '${content}'`;

      const geminiResponse = await this.fetchGeminiStreaming("response", message, "ai_doubt_response", random)

      // const geminiResponse = await UsersService.AiPrompt("response", message);
      // var responseAi = geminiResponse.response.replaceAll("*", "").replaceAll("\n\n", "<span class='space'></span>");
      // var chars = responseAi.split('');
      // for (var i = 0; i < chars.length; i++) {
      //   var str = _this.state.ai_doubt_response || "";
      //   await new Promise(r => setTimeout(r, 6));
      //   _this.setState({
      //     "ai_doubt_response": str + chars[i]
      //   });
      // }

      this.setState({
        "ai_doubt_response_finish": true
      });
    } else {
      _this.setState({
        "ai_doubt_response": null,
        "ai_doubt_response_finish": false,
        "ai_doubt": null
      });
    }
  }

  splitText() {

  }

  async getAiContent(message) {
    const responseAi = await axios.post(`https://rdpparseplataformapi.azurewebsites.net/api/openai`, {
      "text": message
    });

    return responseAi;
  }

  async bufferToBase64(buffer) {
    // use a FileReader to generate a base64 data URI:
    const base64url = await new Promise(r => {
      const reader = new FileReader()
      reader.onload = () => r(reader.result)
      reader.readAsDataURL(new Blob([buffer]))
    });
    // remove the `data:...;base64,` part from the start
    return base64url.slice(base64url.indexOf(',') + 1);
  }

  async getAiImage(message) {
    // const responseAi = await axios.post(`https://rdpparseplataformapi.azurewebsites.net/api/openai/dalle`, {
    //   "text": message
    // });

    // return responseAi.data.image;
    const geminiResponse = await UsersService.AiImagePrompt("image", message);
    const image = await this.bufferToBase64(geminiResponse);

    return `data:image/png;base64,${image}`
  }

  async getAiSupplementaryContent() {
    var _this = this;
    // var content = document.querySelector(".rdp-composer-player-home").innerText;
    var content = this.state.ai_dom_content;
    // var message = `Me sugira 1 módulo de curso relacionado ao conteudo textual a seguir: '${content}'.`;
    

    var chars = "Aguarde, estamos criando seu conteúdo personalizado...";
    for (var i = 0; i < chars.length; i++) {
      var str = _this.state.ai_supplementary_creating_message || "";
      await new Promise(r => setTimeout(r, 6));
      _this.setState({
        "ai_supplementary_creating_message": str + chars[i]
      });
    }

    // const responseAi = await _this.getAiContent(message);

    // var message = `Me sugira um conteúdo com título e texto em html com no mínimo 8000 caracteres, relacionado ao conteúdo a seguir: ${content}`;

    // var message = `Me escreva um título relacionado ao conteudo textual a seguir: '${content}'.`;
    // const geminiResponse = await UsersService.AiPrompt("response", message);
    // var response = geminiResponse.response;

    // var mod;
    // try {
    //   mod = JSON.parse(response.split("json")[1].split("```")[0]);
    // } catch(e) {
    //   mod = response;
    // }

    var random = (Math.random() + 1).toString(36).substring(7);
    this.setState({
      "ai_doubt_identity": random
    });
    

    var prompt = `Quero um título em h1 e um texto grande em html. Por favor, na resposta não retorne nenhuma tag <body>, nem <html>, somente o que seria dentro do <body>. Também não retorne nenhum markdown e nem asteriscos, apenas com quebras de linhas utilizando '\n', sem menções à vídeos, imagens e questionários. O texto é sobre '${content}'`
    const geminiPromptResponse = await this.fetchGeminiStreaming("response", prompt, "ai_supplementary_content", random)

    this.setState({
      "ai_supplementary_response_finish": true
    });
    
    // const geminiPromptResponse = await UsersService.AiPrompt("response", prompt);
    // var promptResponse = geminiPromptResponse.response;
    // var cont;
    // try {
    //   cont = JSON.parse(promptResponse.split("json")[1].split("```")[0].replaceAll("*", "").replaceAll("\n\n", "<span class='space'></span>"))
    // } catch (e) {
    //   cont = promptResponse.replaceAll("\n\n", "<span class='space'></span>").replaceAll("*", "");
    // }
    
    
    var imagePrompt = `Me gere uma imagem realista sem textos por cima sobre: ${content}`;
    var moduleThumb = await _this.getAiImage(imagePrompt);

    // var temp = [{
    //   "title": mod.title,
    //   "content": cont.content || cont,
    //   "thumb": moduleThumb
    // }];

    // var modules = responseAi.data.result.split("\n").filter(item => item !== "" && item !== ".");
    // for (var i = 0; i < modules.length; i++) {
    //   var prompt = `Me escreva um conteúdo grande sobre '${modules[i]}'`
    //   var imagePrompt = `Me gere uma imagem realista sem textos por cima sobre: ${modules[i]}`;
    //   var moduleThumb = await _this.getAiImage(imagePrompt);
    //   var moduleResponseAi = await _this.getAiContent(prompt);
    //   var moduleContent = moduleResponseAi.data.result;
    //   temp.push({
    //     "title": modules[i].split(":")[1],
    //     "content": moduleContent,
    //     "thumb": moduleThumb
    //   })
    // }

    this.setState({
      "ai_supplementary_thumb": moduleThumb
    })

    // var items = responseAi.data.result.split("\n").filter(item => item !== "" && item !== ":");
    // var items = JSON.parse(responseAi.data.result);

  }

  async getAiSupplementaryContentOpenAi() {
    var _this = this;
    // var content = document.querySelector(".rdp-composer-player-home").innerText;
    var content = this.state.ai_dom_content;
    // var message = `Me sugira 1 módulo de curso relacionado ao conteudo textual a seguir: '${content}'.`;
    var message = `Me sugira um conteúdo com título e texto em html com no mínimo 10000 caracteres, relacionado ao conteúdo a seguir: ${content}`;

    var chars = "Aguarde, estamos criando seu conteúdo personalizado...";
    for (var i = 0; i < chars.length; i++) {
      var str = _this.state.ai_supplementary_creating_message || "";
      await new Promise(r => setTimeout(r, 6));
      _this.setState({
        "ai_supplementary_creating_message": str + chars[i]
      });
    }

    const responseAi = await _this.getAiContent(message);

    var temp = [];
    var modules = responseAi.data.result.split("\n").filter(item => item !== "" && item !== ".");
    for (var i = 0; i < modules.length; i++) {
      var prompt = `Me escreva um conteúdo grande sobre '${modules[i]}'`
      var imagePrompt = `Me gere uma imagem realista sem textos por cima sobre: ${modules[i]}`;
      var moduleThumb = await _this.getAiImage(imagePrompt);
      var moduleResponseAi = await _this.getAiContent(prompt);
      var moduleContent = moduleResponseAi.data.result;
      temp.push({
        "title": modules[i].split(":")[1],
        "content": moduleContent.replace("\n\n", "").replaceAll("\n\n", "<span class='space'></span>"),
        "thumb": moduleThumb
      })
    }

    this.setState({
      "ai_supplementary_content": temp[0]
    })

    // var items = responseAi.data.result.split("\n").filter(item => item !== "" && item !== ":");
    // var items = JSON.parse(responseAi.data.result);

  }

  onToggleAiSupplementaryContent() {
    if (!this.state.render_ai_supplementary_content) this.getAiSupplementaryContent();
    if (this.state.render_ai_supplementary_content) {
      this.setState({
        "ai_supplementary_content": null
      })
    }

    this.setState({
      "render_ai_supplementary_content": !this.state.render_ai_supplementary_content
    });
  }

  onToggleAiDoubts() {
    // if (!this.state.render_ai_doubts) this.getAiDoubts();
    // if (this.state.render_ai_doubts) {
    //   this.setState({
    //     "ai_doubts": null
    //   })
    // }

    this.setState({
      "render_ai_doubts": !this.state.render_ai_doubts
    });
  }

  ontoggleAiOptions() {
    this.setState({
      "render_ai_options": !this.state.render_ai_options
    });
  }

  ontoggleAi() {
    this.setState({
      "render_ai": !this.state.render_ai
    });
  }

  onToggleSummary() {
    this.setState({
      "render_summary": !this.state.render_summary
    });
  }

  redirectTo(path) {
    this.props.history.push(path);
  }
  
  onActivityClick(activityUid) {
    var _this = this;
    this.setState({
      "activity_uid": activityUid
    }, function() {
      _this.getActivity();
    })
    this.onToggleSummary();
    var courseUid = this.props.match.params.courseUid;
    var registerUid = this.props.match.params.registerUid;
    var moduleUid = this.props.match.params.moduleUid;

    _this.redirectTo(`/player/${courseUid}/${registerUid}/${moduleUid}/${activityUid}`);

    // setTimeout(function() {
    //   _this.redirectTo(`/player/${courseUid}/${registerUid}/${moduleUid}/${activityUid}`);
    //   window.location.reload()
    // }, 20)
  }

  cleanToSingleLine(input) {
    return input
      .replace(/\s*\n\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  cleanMarkdown(input) {
    const trimmed = input.trim();

    if (trimmed.startsWith("```")) {
      return trimmed.replace(/^```(\n|)json(\n|)/, "").replace(/\n```$/, "").trim();
    }
    return trimmed;
  }
  
  async getAiDoubts() {
    // var content = document.querySelector(".rdp-composer-player-home").innerText;
    var content = this.state.ai_dom_content;
    var message = `Me sugira 6 dúvidas que um aluno poderia ter com relação ao conteudo textual a seguir: '${content}', em um array de objetos no formato JSON, sendo que o retorno deve ser um array diretamente, sem estar dentro de um objeto. tendo cada questão dentro da chave "doubt".`;

    const geminiResponse = await this.fetchGeminiStreamingJson("response", message)

    // OPEN AI
    // const responseAi = await axios.post(`https://rdpparseplataformapi.azurewebsites.net/api/openai`, {
    //   "text": message
    // });
    // var tempItems = responseAi.data.result.split("\n").filter(item => item !== "" && item !== ":");
    // var items = [];
    // for (let i = 0; i < tempItems.length; i++) {
    //   items.push({
    //     "doubt": tempItems[i]
    //   })
    // }

    // const geminiResp = await UsersService.AiPrompt("response", message);

    if (geminiResponse[0] === undefined && geminiResponse.doubts) {
      geminiResponse = geminiResponse.doubts;
    }

    this.setState({
      "ai_doubts": geminiResponse
      // "ai_doubts": JSON.parse(geminiResponse.response.split("```json")[1].split("```")[0].replaceAll("\n", ""))
    })

    // console.log(items);
  }

  onCloseAiSupplementaryContent() {
    this.setState({
      "render_ai_supplementary_content": false,
      "ai_supplementary_content": null,
      "ai_supplementary_creating_message": null
    })
  }

  onIframeLoad() {
    document.getElementById("scorm-frame").contentWindow.postMessage("RDPEvent:initialize", "*");
  }

  onActivityNavigate(position) {
    const {
      activity_uid,
      activities_navigation
    } = this.state;

    var courseUid = this.props.match.params.courseUid;
    var registerUid = this.props.match.params.registerUid;
    var moduleUid, activityUid;
    for (var i = 0; i < activities_navigation.length; i++) {
      if (activities_navigation[i].activity_uid === activity_uid) {
        if (position === "prev") {
          moduleUid = activities_navigation[i - 1].node_uid;
          activityUid = activities_navigation[i - 1].activity_uid;  
        }
        if (position === "next") {
          moduleUid = activities_navigation[i + 1].node_uid;
          activityUid = activities_navigation[i + 1].activity_uid;  
        }
      };
    };

    var _this = this;
    this.setState({
      "activity_uid": activityUid
    }, function() {
      _this.getActivity();
    })

    _this.redirectTo(`/player/${courseUid}/${registerUid}/${moduleUid}/${activityUid}`);
  }

  async openMicroscopio() {
    var activity = this.state.activity;
    var interactionUid = activity.interaction_uid;
    var contentOptions = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/interaction/uid/${interactionUid}/content/options`, null, 'GET');
    var options = btoa(JSON.stringify(contentOptions));
    fetch(`app://0.0.0.1/proxy/system/action?event=unity&custom_options=${options}`);
  }

  render() {
    var _this = this;
    const {
      ai_supplementary_creating_message,
      ai_supplementary_title,
      ai_supplementary_content,
      ai_supplementary_response_finish,
      ai_supplementary_thumb,
      render_ai_supplementary_content,
      ai_doubt_response_finish,
      ai_doubt_response,
      ai_doubt,
      render_ai_doubt,
      render_ai_doubts,
      ai_doubts,
      render_ai_options,
      render_ai,
      render_summary,
      submodules,
      content_uid,
      interaction_uid,
      node_uid,
      content_url,
      activity,
      activity_uid,
      activities_navigation,
      ai_dom_content,
      has_ai_connector,
      render_leave_dialog,
    } = this.state;

    
    return <div className="rdp-react-template-view-player">
      {render_leave_dialog &&
        <Dialog
          title="Você deseja sair desta atividade?"
          onClose={() => this.setState({"render_leave_dialog": false})}
          onConfirm={() => this.onBack()}
        />
      }
      {content_url &&
        <>
          <div className="rdp-react-template-view-player-menu">
            <button className="rdp-react-template-view-player-menu-back" onClick={() => this.setState({"render_leave_dialog": true})}></button>
            {has_ai_connector && ai_dom_content.length > 0 &&
              <button className="rdp-react-template-view-player-menu-chatbot" onClick={() => this.ontoggleAiOptions()}></button>
            }
            <button className="rdp-react-template-view-player-menu-summary" onClick={() => this.onToggleSummary()}></button>
          </div>
          {render_summary && submodules &&
            <div className="rdp-react-template-view-player-summary-view">
              <div className="rdp-react-template-view-player-menu">
                <span className="rdp-react-template-view-player-menu-title">Atividades</span>
                <button className="rdp-react-template-view-player-menu-close" onClick={() => this.onToggleSummary()}></button>
              </div>
              <ul className="rdp-react-template-view-player-summary">
                {submodules.map(function(submodule, index) {
                  return <li key={index} className={`rdp-react-template-view-player-summary-item`}>
                    <span key={index} className={`rdp-react-template-view-player-summary-item-title`}>
                      {submodule.data.title}
                    </span>
                    {submodule.activities.map(function(act, index) {
                      return <li key={index} className={`rdp-react-template-view-player-summary-item-activity ${_this.downloadedActivity(act) ? "downloaded" : ""} ${act.uid === activity_uid ? "active" : ""}`} onClick={() => _this.onActivityClick(act.uid)}>
                        <span className="rdp-react-template-view-player-summary-item-activity-number">{index + 1}</span>
                        <div className="rdp-react-template-view-player-summary-item-activity-data">
                          <span className="rdp-react-template-view-player-summary-item-activity-data-title">{act.name}</span>
                        </div>
                        <span className={`rdp-react-template-view-player-summary-item-activity-play ${act.status}`}>
                          <div style={{ width: 50, height: 50, marginTop: "-1px", marginLeft: "-1px" }}></div>
                        </span>
                      </li>
                    })}
                  </li>
                })}
              </ul>
            </div>
          }
          
          {render_ai_options &&
            <div className="rdp-react-template-view-player-ai-options">
              <div className="rdp-react-template-view-player-ai-options-menu" data-aos="fade-down" data-aos-duration="500">
                <div className="rdp-react-template-view-player-ai-options-menu-header">
                  <span className="rdp-react-template-view-player-ai-options-menu-header-back" onClick={() => this.ontoggleAiOptions()}></span>
                  <h1 className="rdp-react-template-view-player-ai-options-menu-header-title">Como posso te ajudar, hoje?</h1>
                </div>
                <div className="rdp-react-template-view-player-ai-options-menu-items">
                  <div className="rdp-react-template-view-player-ai-options-menu-item" onClick={() => this.onToggleAiDoubts()}>
                    <span className="rdp-react-template-view-player-ai-options-menu-item-icon help"></span>
                    {/* <h5 className="rdp-react-template-view-player-ai-options-menu-item-label">Estou com dúvidas relacionadas a este conteúdo e preciso de ajuda.</h5> */}
                    <h5 className="rdp-react-template-view-player-ai-options-menu-item-label">Estou em dúvida neste conteúdo e preciso de ajuda para entender.</h5>
                  </div>
                  <div className="rdp-react-template-view-player-ai-options-menu-item" onClick={() => this.onToggleAiSupplementaryContent()}>
                    <span className="rdp-react-template-view-player-ai-options-menu-item-icon recommended"></span>
                    <h5 className="rdp-react-template-view-player-ai-options-menu-item-label">Quero um conteúdo personalizado para aprofundar meus conhecimentos.</h5>
                  </div>
                </div>
              </div>
              <div className="rdp-react-template-view-player-ai-options-overlay" onClick={() => this.ontoggleAiOptions()}></div>
            </div>
          }

          {render_ai &&
            <div className="rdp-react-template-view-player-ai-view">
              <div className="rdp-react-template-view-player-menu">
                <button className="rdp-react-template-view-player-menu-back" onClick={() => this.onToggleAi()}></button>
              </div>
            </div>
          }

          {render_ai_doubts &&
            <div className="rdp-react-template-view-player-ai-doubts">
              <div className="rdp-react-template-view-player-ai-options-menu-header">
                <span className="rdp-react-template-view-player-ai-options-menu-header-back" onClick={() => this.onToggleAiDoubts()}></span>
                <h1 className="rdp-react-template-view-player-ai-options-menu-header-title">Em qual tópico deseja se aprofundar?</h1>
              </div>
              {ai_doubts === null &&
                <div className="rdp-react-template-view-player-ai-doubts-preloader"></div>
              }
              {ai_doubts !== null &&
                <ul className="rdp-react-template-view-player-ai-doubts-items" data-aos="fade-up" data-aos-duration="500">
                  <li className="rdp-react-template-view-player-ai-doubts-avatar"></li>
                  {ai_doubts.map(function(doubt, index) {
                    return <li onClick={() => _this.onToggleAiDoubt(index)} className={`rdp-react-template-view-player-ai-doubts-item ${index === 0 ? "first" : ""}`} key={index}>{doubt.doubt}</li>
                  })}
                </ul>
              }
            </div>
          }

          {render_ai_doubt &&
            <div className="rdp-react-template-view-player-ai-doubt">
              <div className="rdp-react-template-view-player-ai-options-menu-header">
                <span className="rdp-react-template-view-player-ai-options-menu-header-back" onClick={() => this.onToggleAiDoubt(null)}></span>
                {/* <h1 className="rdp-react-template-view-player-ai-options-menu-header-title">Em qual tópico deseja se aprofundar?</h1> */}
              </div>
              <div className="rdp-react-template-view-player-ai-doubt-content">
                <div style={{ fontSize: '25px', lineHeight: '30px', display: 'inline-block', color: "#FFF" }}>
                  {ai_doubts[ai_doubt].doubt}
                </div>

                <div className="rdp-react-template-view-player-ai-doubt-window">
                  {ai_doubt_response === null &&
                    <div className="rdp-react-template-view-player-ai-doubt-window-icon">
                      {/* <span className="rdp-react-template-view-player-ai-doubt-window-icon-avatar"></span> */}
                    </div>
                  }
                  {ai_doubt_response !== null &&
                    <>
                      <div className={`rdp-react-template-view-player-ai-doubt-window-icon ${ai_doubt_response_finish ? "finished" : ""}`}>
                        {/* <span className="rdp-react-template-view-player-ai-doubt-window-icon-avatar"></span> */}
                      </div>
                      <div className="rdp-react-template-view-player-ai-doubt-window-box">
                        <span style={{ fontSize: '16px', lineHeight: '30px', display: 'inline-block', color: "#FFF" }} dangerouslySetInnerHTML={{__html: ai_doubt_response.replace("\n\n", "").replaceAll("\n\n", "<span class='space'></span>")}}></span>
                        {/* {ai_doubt_response_finish &&
                          <>
                            <span className="rdp-react-template-view-player-ai-doubt-window-title">Deseja ter acesso a conteúdo complementar personalizado para expandir seu conhecimento?</span>
                            <button className="rdp-react-template-view-player-ai-doubt-window-button">Clique aqui para acessar</button>
                          </>
                        } */}
                      </div>
                    </>
                  }
                </div>
              </div>
              
              {/* {ai_doubts === null &&
                <div className="rdp-react-template-view-player-ai-doubts-preloader"></div>
              }
              {ai_doubts !== null &&
                <ul className="rdp-react-template-view-player-ai-doubts-items" data-aos="fade-up" data-aos-duration="500">
                  <li className="rdp-react-template-view-player-ai-doubts-avatar"></li>
                  {ai_doubts.map(function(doubt, index) {
                    return <li onClick={() => _this.openDoubt(index)} className={`rdp-react-template-view-player-ai-doubts-item ${index === 0 ? "first" : ""}`} key={index}>{doubt}</li>
                  })}
                </ul>
              } */}
            </div>
          }

          {render_ai_supplementary_content &&
            <div className="rdp-react-template-view-player-ai-supplementary-content">
              {/* <div className="rdp-react-template-view-player-ai-options-menu-header">
                <span className="rdp-react-template-view-player-ai-options-menu-header-back" onClick={() => this.onToggleAiDoubt(null)}></span>
                <h1 className="rdp-react-template-view-player-ai-options-menu-header-title">Em qual tópico deseja se aprofundar?</h1>
              </div> */}
              <div className="rdp-react-template-view-player-ai-supplementary-content-body">
                {ai_supplementary_content === null &&
                  <>
                    <span className="rdp-react-template-view-player-ai-supplementary-generated-back" onClick={() => this.onCloseAiSupplementaryContent(null)}></span>
                    {/* <span style={{ fontSize: '25px', lineHeight: '30px', display: 'inline-block', color: "#FFF", marginTop: "50px" }}>{ai_supplementary_creating_message}</span> */}
                    <div className="rdp-react-template-view-player-ai-doubt-window-icon" style={{marginTop: "50px"}}></div>
                  </>
                }
                {ai_supplementary_content !== null &&
                  <div className="rdp-react-template-view-player-ai-supplementary-generated">
                    {/* <div className="rdp-react-template-view-player-ai-supplementary-generated-thumb" style={{height: `${window.innerWidth - 40}px`, backgroundImage: `url(${ai_supplementary_thumb})`}}>
                      <div className="rdp-react-template-view-player-ai-supplementary-generated-thumb-shadow">
                        <h3 className="rdp-react-template-view-player-ai-supplementary-generated-title">{ai_supplementary_title}</h3>
                      </div>
                      <span className="rdp-react-template-view-player-ai-supplementary-generated-back" onClick={() => this.onCloseAiSupplementaryContent(null)}></span>
                    </div> */}
                    <span className="rdp-react-template-view-player-ai-supplementary-generated-back" onClick={() => this.onCloseAiSupplementaryContent(null)}></span>
                    <div className={`rdp-react-template-view-player-ai-doubt-window-icon ${ai_supplementary_response_finish ? "finished" : ""}`} style={{marginTop: "50px"}}></div>
                    <div className="rdp-react-template-view-player-ai-supplementary-generated-text" dangerouslySetInnerHTML={{__html: ai_supplementary_content}}></div>
                  </div>
                }
                
              </div>
            </div>
          }

          <div className="rdp-react-template-view-player-container">
            {content_url &&
              <>
                <div className="rdp-react-template-view-login-preloader" style={{top: "0px!important", zIndex: "1"}}>
                  <div className="rdp-react-template-view-login-preloader-loader"></div>
                </div>

                {activity.uid !== "dcd5dff5-d392-ef11-88cf-6045bdd9c543" &&
                  <iframe
                    id="scorm-frame"
                    className={`rdp-react-template-view-player-iframe ${this.downloadedActivity(activity) ? "downloaded" : ""}`}
                    title="Conteúdo"
                    allowFullScreen
                    allow={"camera; microphone; display-capture; autoplay; clipboard-write; encrypted-media"}
                    onLoad={() => this.onIframeLoad()}
                    src={content_url}
                  ></iframe>
                }

                {activity.uid === "dcd5dff5-d392-ef11-88cf-6045bdd9c543" &&
                  <div className="rdp-react-template-view-player-microscopio">
                    <button onClick={() => this.openMicroscopio()}>Clique aqui para abrir a experiência do microscópio</button>
                  </div>
                }

                <div className={`rdp-react-template-view-player-offline ${this.downloadedActivity(activity) ? "downloaded" : ""}`} style={{zIndex: 3, backgroundColor: "#d4d3c8"}}>
                  <span className="rdp-react-template-view-player-offline-icon"></span>
                  <h1 className="rdp-react-template-view-player-offline-title">Você está offline!</h1>
                  <p className="rdp-react-template-view-player-offline-description">Conecte seu dispositivo à internet para acessar esta atividade online ou faça o download para acessá-la offline.</p>
                </div>
{/* 
                <Draggable
                  axis="both"
                  handle=".rdp-react-template-view-player-navigation-drag"
                  bounds="parent"
                  defaultPosition={{x: (window.innerWidth - 230) / 2, y: window.innerHeight - 130}}
                > */}
                  {activities_navigation &&
                    <div className="rdp-react-template-view-player-navigation">
                      <button className={`rdp-react-template-view-player-navigation-btn prev ${activities_navigation.find(act => act.activity_uid === activity_uid).first ? "disabled" : ""}`} onClick={() => this.onActivityNavigate("prev")}>Anterior</button>
                      <button className={`rdp-react-template-view-player-navigation-btn next ${activities_navigation.find(act => act.activity_uid === activity_uid).last ? "disabled" : ""}`} onClick={() => this.onActivityNavigate("next")}>Próximo</button>
                      <div className="rdp-react-template-view-player-navigation-drag"></div>
                    </div>
                  }
                {/* </Draggable> */}
              </>
              // <ViewHome customOptions={this.getCustomOptions()}/>
            }
          </div>
        </>
      }
    </div>;
  }
}
